


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Collection, View, ComponentType, Indicator, IndicatorType } from '@/models'
import PaginatedList from '@/components/PaginatedList.vue'
import ComponentCreateDialog from '@/components/ComponentCreateDialog.vue'
import { CreateElement } from 'vue'
import gql from 'graphql-tag'
import * as ComponentTypes from '..'

@Component({
  components: {
    PaginatedList,
    ComponentCreateDialog
  },
  apollo: {
    indicatorTypes: gql`query {
      indicatorTypes {
        _id
        name
      }
    }`
  }
})
export default class AdminComponentsIndicatorsList extends Vue {
  /** Current Environment ID */
  @Prop({ type: String, required: true }) environmentId !: string
  /** Current component type name */
  @Prop({ type: String, required: true }) componentTypeName !: string

  indicatorTypes !: IndicatorType[]

  /** Current search query */
  searchQuery = ''
  /** Current sorting mode */
  sortBy = 'name'
  /** Create modal state */
  createModalOpen = false

  /** Current component type */
  get componentType () : ComponentType<any> {
    return (ComponentTypes as Record<string, ComponentType<any>>)[this.componentTypeName]
  }

  transformResult (input : Indicator) {
    const typeDef = this.indicatorTypes.find(t => t._id === input.indicatorTypeId)
    return {
      ...this.componentType.transformResult(input),
      subtitle: typeDef ? typeDef.name : input.indicatorTypeId
    }
  }

  /** Open or close the creation modal */
  toggleCreateModal (value : any) {
    this.createModalOpen = value != null && typeof value === 'boolean' ? value : !this.createModalOpen
  }

  handleCreate (component : any) {
    if (component && component._id) {
      return this.$router.push(`${this.componentType.namespace}/${component._id}`)
    }
  }
}
